import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import { useToasts } from 'react-toast-notifications'
import _ from 'lodash'

import { WarningModal } from '../../../ui'
import { Error } from '../../../form'
import { handleBackEndErrors } from '../../../../utilities'

export const DeleteNoteModal = ({
  note,
  name,
  isVisible,
  setModalVisibility,
  submitResponse,
  setNoteToDelete,
}) => {
  const { addToast } = useToasts()
  const [backEndErrors, setBackEndErrors] = React.useState({})

  const DeleteNote = async id => {
    axios({
      method: 'post',
      url: `/v1/clients/notes/${id}/delete`,
    })
      .then(response => {
        if (response.data.success) {
          submitResponse(note, 'delete')
          setModalVisibility(false)
          addToast('Note deleted successfully', { appearance: 'success' })
          setNoteToDelete({})
        } else {
          addToast('Error deleting note, please try again', {
            appearance: 'error',
          })
        }
      })
      .catch(error => {
        if (error.response.status === 422) {
          setBackEndErrors(error.response.data.errors)
        } else {
          setBackEndErrors(error.response.data.error)
        }
        addToast('Error deleting note, please try again', {
          appearance: 'error',
        })
      })
  }

  return (
    <WarningModal
      isVisible={isVisible}
      heading="Delete Note?"
      closeFunc={() => setModalVisibility(false)}
      submitButtonText="Delete note"
      submitFunc={() => DeleteNote(note.id)}
      backEndErrors={backEndErrors}
    >
      <b>{name}</b> will no longer exist
      {_.isEmpty(backEndErrors) ? (
        ''
      ) : (
        <Error>{handleBackEndErrors(backEndErrors)}</Error>
      )}
    </WarningModal>
  )
}

DeleteNoteModal.propTypes = {
  note: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  isVisible: PropTypes.bool.isRequired,
  setModalVisibility: PropTypes.func.isRequired,
  submitResponse: PropTypes.func.isRequired,
  setNoteToDelete: PropTypes.func.isRequired,
}
